import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconCrosshairs = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	fillRule: "evenodd",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeMiterlimit: 1.4,
	clipRule: "evenodd",
	viewBox: "0 0 1024 1024",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			d: "M0 0h1024v1024H0z"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 4542.11,
			cy: 534.805,
			r: 406.805,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 83.38,
			transform: "matrix(.8635 0 0 .8635 -3410.09 50.198)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 4542.11,
			cy: 534.805,
			r: 406.805,
			fill: "currentColor",
			stroke: "currentColor",
			strokeWidth: 813.61,
			transform: "matrix(.0885 0 0 .0885 112.234 464.673)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 72,
			d: "m509.82 64 4.37 236M512 960l2.19-236M960 512H725.99M64 512h236"
		})
	]
});
export default SvgIconCrosshairs;
